
define('text!samples/meteorites/README.md',[],function () { return 'Meteorites are falling from the sky.\n\nMake sure none reach the ground.\n\n**How to play**\n\nUse the Left and Right arrows of your keyboard to aim.\n\nUse the Space bar to fire.';});

